


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Policy extends Vue {
  public clickMe(): void {
    const helloWorld = 'Hello World';

    console.log('test');
  }
}
